var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loaded)?_c('div',_vm._l((_vm.contentItems),function(item,index){return _c('toggle-content',{attrs:{"name":"faq","label":item.faq_question,"index":index,"icon":"arrow"}},[_vm._v("\n        "+_vm._s(_vm.getContent(item))+"\n    ")])}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }